import { render, staticRenderFns } from "./myCreate.vue?vue&type=template&id=51eac4b6&scoped=true"
import script from "./myCreate.vue?vue&type=script&lang=js"
export * from "./myCreate.vue?vue&type=script&lang=js"
import style0 from "./myCreate.vue?vue&type=style&index=0&id=51eac4b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eac4b6",
  null
  
)

export default component.exports